import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-push-to-web',
  templateUrl: './push-to-web.component.html',
  styleUrls: ['./push-to-web.component.scss'],
})
export class PushToWebComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
